import React, { useState, useEffect } from 'react'

import TreatmentPlanForm from '../treatment-plan-form/TreatmentPlanForm';
import moment from 'moment'
import APIResponse from '../../../../templates/components/APIResponse';
import TreatmentPlanService from '../../../../../services/api/treatment-plan.service';
import Utilities from '../../../../../services/commonservice/utilities';
const TreatmentPlanEdit = (props) => {
    const [formData, setFormData] = useState(props.initialData||{})
    const [messages, setMessages] = useState({})
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const submitHandler = (data, details) => {
        let reqObj = { ...data }
        // console.log(JSON.stringify(data))
        // console.log(JSON.stringify(details))
        reqObj.treatmentPlanDetail = details.map(x => {
            x.quantity = x.quantity ? +x.quantity : null
            x.statusId = x.statusId ? +x.statusId : null
            x.datePlanned = x.datePlanned ? Utilities.toDate(x.datePlanned): null
            delete x.index
            return x
        })
        setIsLoader(true)
        TreatmentPlanService.editTreatmentPlan(reqObj)
            .then(response => {
                setApiResponse(response)
                setIsLoader(false)
            })
            .catch(error => {
                setApiResponse(error)
                setIsLoader(false)
            })
    }

    return (
        <div>
            <TreatmentPlanForm submitHandler={submitHandler} initialData={formData} messages={messages} isEdit
                submitLabel="Update" isLoader={isLoader} onClose={() => props.onClose()} patient={props.patient} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </div>
    )
}

export default TreatmentPlanEdit